var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"theme-background ma-0 mb-2 flex-grow-1",class:_vm.selected === _vm.reason ? 'theme-green-border' : 'theme-border',attrs:{"width":"100%","min-height":"44px","outlined":""},on:{"click":_vm.selectRejectReason}},[_vm._v(" "+_vm._s(_vm.getRejectReasonLabel())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }